import apiClient from '../../../services/api';

export type FarmBriefLang = 'en' | 'fil';

function filenameFromDisposition(header: string | undefined, fallback: string): string {
  const match = /filename="?([^"]+)"?/i.exec(header || '');
  return match?.[1] || fallback;
}

/** Download today's farm brief. The API reuses the copy saved for this farm today. */
export async function downloadFarmBriefPdf(
  farmId: string | number,
  lang: FarmBriefLang,
  farmName?: string | null
): Promise<void> {
  const id = String(farmId);
  const response = await apiClient.get(`/farm-report-brief/${encodeURIComponent(id)}/pdf`, {
    params: { lang, farm_name: farmName || undefined },
    responseType: 'blob',
    timeout: 180000,
  });
  const blob = response.data as Blob;
  if (blob.type && blob.type.includes('json')) {
    const text = await blob.text();
    throw new Error(text || 'Could not build the farm brief.');
  }
  const filename = filenameFromDisposition(
    response.headers?.['content-disposition'],
    `farm_brief_${lang}.pdf`
  );
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
